import { NavItemExternalLink } from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem';
import { useProfile } from '@/hooks';
import { buildLink } from '@/utils';
import { useTranslation } from 'react-i18next';

export function useMoreSubmenuItems() {
  const { t } = useTranslation();
  const profile = useProfile();
  const manager = profile.manager;
  const menuItems = [];

  if (manager.rechte.konflikte) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('konflikte')}>
        {t('entities.conflict_other')}
      </NavItemExternalLink>,
    );
  }
  if (manager.rechte.termine) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('termine')}>
        {t('entities.event_other')}
      </NavItemExternalLink>,
    );
  }

  if (manager.rechte.mitarbeiter.dokumente) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('dokumente')}>
        {t('entities.document_other')}
      </NavItemExternalLink>,
    );
  }

  if (manager.rechte.neuigkeiten) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('neuigkeiten')}>
        {t('entities.neuigkeiten')}
      </NavItemExternalLink>,
    );
  }

  return menuItems;
}
